import PropTypes from "prop-types";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { BookmarkTippyContent } from "./BookmarkTippyContent";
import { FolderBookmarkButton } from "./FolderBookmarkButton";

export const FolderDropdown = ({ bookmark = {}, onToggle, children }) => (
  <Dropdown
    direction="bottom-start"
    size="large"
    onToggle={onToggle}
    appendTo={document.body}
    transitionWrapperClassName="pt-1.5"
    button={
      <Dropdown.MenuButton className="!py-0">
        <TippyV2
          interactive={false}
          content={<BookmarkTippyContent bookmark={bookmark} />}
          flip="false"
          boundary="window"
          arrow
          size="medium"
          animation="fade"
          placement="top"
          touch={false}
        >
          <FolderBookmarkButton bookmark={bookmark} />
        </TippyV2>
      </Dropdown.MenuButton>
    }
  >
    {children}
  </Dropdown>
);

FolderDropdown.propTypes = {
  bookmark: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  onToggle: PropTypes.func,
  children: PropTypes.node,
};
